import { Outlet } from 'react-router-dom';
import { SiteFooter } from './site-footer';
import { SiteHeader } from './site-header';

/**
 * The shared header and footer, around every page but three.
 *
 * The landing page, the booking wizard and the legal document are those three. Each carries its own
 * navigation ported from the live static site — inside the hero, a slim wizard bar, a bar without
 * the marketing links — so they are routed as siblings of this rather than children, and the chrome
 * is a layout route instead of something `LanguageLayout` renders for everybody and those pages
 * then have to hide.
 *
 * **This is also where the dark appearance begins and ends**, and the boundary is the same one for
 * the same reason. The pages under this chrome — the blog, an article, the account screens, the
 * portal, the not-found page — are the ones with a dark pass; the three ported pages have exactly
 * one appearance. Painting the ground here rather than on `body` is what stops the switch on this
 * side turning those pages' dark text onto a dark ground the moment somebody navigates across.
 */
export function SiteChrome() {
    return (
        <div className="flex min-h-full flex-col bg-slate-50 transition-colors dark:bg-slate-950">
            <SiteHeader />
            <main className="flex-1">
                <Outlet />
            </main>
            <SiteFooter />
        </div>
    );
}
